<template><div class="header"><div><h1>{{ title }}</h1><p class="muted page-description">{{ description }}</p></div></div></template>
<script>
export default { props: { title: String, description: String } }
</script>
